import { z } from 'zod';
import { zTranslatableBothRequired } from './translatable.js';
/** Admin "save team member" payload. Mirrors Admin\TeamController::save(). */
export const teamMemberSaveSchema = z.object({
    firstName: zTranslatableBothRequired,
    lastName: zTranslatableBothRequired,
    position: zTranslatableBothRequired,
    shortDescription: zTranslatableBothRequired,
    longDescription: zTranslatableBothRequired,
    linkedin: z.string().url('Must be a valid URL'),
    email: z.string().email(),
    telephone: z.string().regex(/^\+?[0-9 ]+$/, 'Digits, spaces and an optional leading + only'),
    photoPath: z.string().nullable().optional(),
});
//# sourceMappingURL=teamMember.js.map